<h2 *ngIf="title" class="summary-card__title">{{ title }}</h2>
<a *ngIf="linkTarget" class="summary-card__edit" [routerLink]="[linkTarget]" i18n="@@general.summary-card.edit">edit</a>
<div class="content">
    <ng-content></ng-content>
</div>
